// extracted by mini-css-extract-plugin
export default {"recommendedCard":"style_recommendedCard__kKDgj"};